import React from 'react';
import useNewOnboarding from './hooks/useNewOnboarding';
import { STEPS } from './constants/onboardingData';

// Components - Flow commun
import Step1UserType from './components/Step1UserType';
import SuccessScreen from './components/SuccessScreen';

// Components - Flow Parent
import Step2ChildInfo from './components/Step2ChildInfo';
import Step3Availability from './components/Step3Availability';
import Step4Duration from './components/Step4Duration';
import Step5Goals from './components/Step5Goals';
import Step6SocialProof from './components/Step6SocialProof';

// Components - Flow Élève
import Step1StudentName from './components/Step1StudentName';
import Step2StudentClass from './components/Step2StudentClass';
import Step3StudentInfo from './components/Step3StudentInfo';
import Step4ParentContact from './components/Step4ParentContact';

/**
 * Page principale du nouvel onboarding
 */
export default function NewOnboardingPage() {
  const {
    step,
    formData,
    currentStepNumber,
    currentStepMessage,
    totalSteps,
    canContinue,
    validationMessage,
    handleSelectUserType,
    handleUpdateChildInfo,
    handleToggleDifficulty,
    handleToggleAvailability,
    handleSelectDuration,
    handleToggleGoal,
    // Handlers flow élève
    handleUpdateStudentInfo,
    handleToggleStudentDifficulty,
    handleSetParentContact,
    // Handlers communs
    handleContinue,
    handleBack,
    handleComplete,
    handleNavigateToAction,
  } = useNewOnboarding();

  // Rendu conditionnel selon l'étape
  const renderStep = () => {
    switch (step) {
      // Étape commune
      case STEPS.USER_TYPE:
        return (
          <Step1UserType
            onSelectType={handleSelectUserType}
          />
        );

      // ========== FLOW PARENT ==========
      case STEPS.CHILD_INFO:
        return (
          <Step2ChildInfo
            formData={formData}
            currentStepNumber={currentStepNumber}
            currentStepMessage={currentStepMessage}
            canContinue={canContinue}
            validationMessage={validationMessage}
            onUpdateChildInfo={handleUpdateChildInfo}
            onToggleDifficulty={handleToggleDifficulty}
            onContinue={handleContinue}
            onBack={handleBack}
          />
        );

      case STEPS.AVAILABILITY:
        return (
          <Step3Availability
            formData={formData}
            currentStepNumber={currentStepNumber}
            currentStepMessage={currentStepMessage}
            canContinue={canContinue}
            onToggleAvailability={handleToggleAvailability}
            onContinue={handleContinue}
            onBack={handleBack}
          />
        );

      case STEPS.DURATION:
        return (
          <Step4Duration
            formData={formData}
            currentStepNumber={currentStepNumber}
            currentStepMessage={currentStepMessage}
            canContinue={canContinue}
            onSelectDuration={handleSelectDuration}
            onContinue={handleContinue}
            onBack={handleBack}
          />
        );

      case STEPS.GOALS:
        return (
          <Step5Goals
            formData={formData}
            currentStepNumber={currentStepNumber}
            currentStepMessage={currentStepMessage}
            canContinue={canContinue}
            validationMessage={validationMessage}
            onToggleGoal={handleToggleGoal}
            onContinue={handleContinue}
            onBack={handleBack}
          />
        );

      case STEPS.SOCIAL_PROOF:
        return (
          <Step6SocialProof
            formData={formData}
            currentStepNumber={currentStepNumber}
            currentStepMessage={currentStepMessage}
            onComplete={handleComplete}
            onBack={handleBack}
          />
        );

      // ========== FLOW ÉLÈVE ==========
      case STEPS.STUDENT_NAME:
        return (
          <Step1StudentName
            formData={formData}
            currentStepNumber={currentStepNumber}
            currentStepMessage={currentStepMessage}
            totalSteps={totalSteps}
            canContinue={canContinue}
            validationMessage={validationMessage}
            onUpdateStudentInfo={handleUpdateStudentInfo}
            onContinue={handleContinue}
            onBack={handleBack}
          />
        );

      case STEPS.STUDENT_CLASS:
        return (
          <Step2StudentClass
            formData={formData}
            currentStepNumber={currentStepNumber}
            currentStepMessage={currentStepMessage}
            totalSteps={totalSteps}
            canContinue={canContinue}
            validationMessage={validationMessage}
            onUpdateStudentInfo={handleUpdateStudentInfo}
            onContinue={handleContinue}
            onBack={handleBack}
          />
        );

      case STEPS.STUDENT_INFO:
        return (
          <Step3StudentInfo
            formData={formData}
            currentStepNumber={currentStepNumber}
            currentStepMessage={currentStepMessage}
            totalSteps={totalSteps}
            canContinue={canContinue}
            validationMessage={validationMessage}
            onUpdateStudentInfo={handleUpdateStudentInfo}
            onToggleStudentDifficulty={handleToggleStudentDifficulty}
            onContinue={handleContinue}
            onBack={handleBack}
          />
        );

      case STEPS.PARENT_CONTACT:
        return (
          <Step4ParentContact
            formData={formData}
            currentStepNumber={currentStepNumber}
            currentStepMessage={currentStepMessage}
            totalSteps={totalSteps}
            canContinue={canContinue}
            validationMessage={validationMessage}
            onUpdateStudentInfo={handleUpdateStudentInfo}
            onSetParentContact={handleSetParentContact}
            onComplete={handleComplete}
            onBack={handleBack}
          />
        );

      // ========== ÉCRAN DE SUCCÈS ==========
      case STEPS.SUCCESS:
        return (
          <SuccessScreen
            formData={formData}
            onNavigateToAction={handleNavigateToAction}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-[100dvh]">
      {renderStep()}
    </div>
  );
}
